import React from 'react';

interface PhoneNumberInputProps {
    selectedCountry?: { value: string } | null; // Adjust this based on your actual type
    mobile: string;
    isdCode: string;
    setmobile: (value: string) => void;
    setIsdCode: (value: string) => void;
    disabled?: boolean;
    showRequiredIndicator?: boolean;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({ selectedCountry, mobile, setmobile, isdCode }) => {
    return (
        <div className="mb-4">
            <div className="flex items-center w-96">
                {/* <div className="flex items-center border border-gray-300 rounded-l-md bg-white">
                    {selectedCountry ? (
                        <span className="p-3 text-gray-700 truncate" style={{ maxWidth: '80px' }}>
                            {isdCode}
                        </span>
                    ) : (
                        <span className="p-3 text-gray-400">-</span>
                    )}
                </div> */}
                {/* <div className="flex items-center px-3 border border-gray-300 bg-gray-100">
                    <span className="text-gray-700">{isdCode}</span>
                </div> */}
                <input
                    type="tel"
                    value={mobile}
                    onChange={(e) => setmobile(e.target.value)}
                    placeholder="123-456-7890"
                    required
                    className="w-full p-3 border border-gray-300 rounded-r-md focus:outline-none focus:ring-2 focus:ring-primary"
                />
            </div>
        </div>
    );
};

export default PhoneNumberInput;